<template>
  <div class="main__sidebar">
    <div class="main__vixio">
      <div
        class="main__vixio-list section-border--top section-border--right section-border--bottom"
      >
        <TitleBlock :text="'Global Filters'" />
        <div v-for="(vocab, index) in vocabularies" :key="index.key">
          <VocabularyDropdown
            :key="{ vocab }"
            :vocabulary="{ vocab }"
            :options="{ vocab }"
          />
        </div>
        <div v-show="filters.hits && filters.hits.length">
          <div v-for="(item, index) in filters.hits" :key="index.key">
            {item.id}
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState, mapGetters } from "vuex";
import { fetchGlobalFilter } from "../../api/elasticRequests/fetchGlobalFilter";
// import filterHierarchies from "../../utils/filter";
export default {
  components: {
    TitleBlock: () => import("../../components/elements/TitleBlock"),
  },
  async fetch({ store }) {
    await store
      .dispatch("Global/getElasticResults", {
        url: "/_search",
        data: fetchGlobalFilter,
      })
      .then(({ data }) => {
        console.log("GlobalFilterNav", data);
      })
      .catch((error) => console.error(error));
  },
  computed: {
    ...mapGetters("Global", ["getElasticResults"]),
    ...mapState("Global", ["filters"]),
    // authoritiesParent() {},
    // vocabularies() {
    //   // calls the ECS endpoint
    // }
  },
  created() {},
  methods: {
    createHierarchies() {},
  },
};
</script>
